export default "__VITE_ASSET__ef6ca164__"